import React from "react";
import { Button, Icon, Tooltip } from "@bookingcom/bui-react";
import { InfoSignIcon } from "@bookingcom/bui-assets-react/streamline";
import styles from "./FlightCardGeniusHighlightTooltipWrapper.module.css";
const FlightCardGeniusHighlightTooltipWrapper = ({ infoTooltip }) => {
    return (React.createElement(Tooltip, { text: infoTooltip.content }, (triggerAttributes) => (React.createElement(Button, { variant: "tertiary", className: styles.geniusHighlightTooltipButton, attributes: {
            ...triggerAttributes
        } },
        React.createElement(Icon, { size: "medium", svg: InfoSignIcon })))));
};
export default FlightCardGeniusHighlightTooltipWrapper;
